export default {
  feature: {
    USER_ONBOARDING: 'User Onboarding',
  },
  action: {
    CLICKED: 'clicked',
  },
};
